export enum OutboundEmailFileType {
  UploadedFile = 'uploadedFile',
  ExistingVersion = 'existingVersion',
  ExistingAttachment = 'existingAttachment',
}
